import styles from "./auth_style.module.css";
import bgImage from "../../assets/images/login_bg.png";

export const AuthPageBackgroundWrapper = ({ children }) => {
	return (
		<div className={`d-flex ${styles.background}`}>
			<div className={`${styles.authChildren}`}>{children}</div>
			<div className={styles.imageContainer}>
				<img src={bgImage} alt="background" />
			</div>
		</div>
	);
};
